const FETCH_LIST_REQUEST = 'FETCH_LIST_REQUEST'
const FETCH_LIST = 'FETCH_LIST'
const FETCH_ERROR = 'FETCH_ERROR'
const FETCH_LIST_PASS = 'FETCH_LIST_PASS'
//BORROWERS DATA
const FETCH_BORROWERS_REQUEST = 'FETCH_BORROWERS_REQUEST'
const FETCH_BORROWERS_LIST = 'FETCH_LIST'
const FETCH_BORROWERS_PASS = 'FETCH_BORROWERS_PASS'
//adding new student 
const ADD_STUDENT = 'ADD_STUDENT'
const ADD_STUDENT_FAIL = 'ADD_STUDENT_FAIL'
const ADD_STUDENT_PASSED = 'ADD_STUDENT_PASSED'

//delete the student
const DELETE_STUDENT = 'DELETE_STUDENT'

//edit the student data
const EDIT_STUDENT = 'EDIT_STUDENT'
//lend book to the student
const LEND_BOOK = 'LEND_BOOK'
// returning book from the students
const RETURN_BOOK = 'RETURN_BOOK'
//getting students records
const FETCH_RECORDS_REQUEST = 'FETCH_RECORDS_REQUEST'
const FETCH_RECORDS_PASS = 'FETCH_RECORDS_PASS'

const FETCH_FINALIST_REQUEST = 'FETCH_FINALIST_REQUEST'
const FETCH_FINALIST_PASS = 'FETCH_FINALIST_PASS'
const FETCH_FINALIST = 'FETCH_FINALIST'
const CONNECTION_ERROR = 'CONNECTION_ERROR'
const CONNECTION_BACK = 'CONNECTION_BACK'

export {
    CONNECTION_BACK,
    CONNECTION_ERROR,
    FETCH_FINALIST,
    FETCH_FINALIST_PASS,
    FETCH_FINALIST_REQUEST,
    FETCH_LIST,
    FETCH_LIST_REQUEST,
    FETCH_LIST_PASS,
    FETCH_ERROR,
    FETCH_BORROWERS_PASS,
    FETCH_BORROWERS_LIST,
    FETCH_BORROWERS_REQUEST,
    ADD_STUDENT,
    ADD_STUDENT_FAIL,
    ADD_STUDENT_PASSED,
    DELETE_STUDENT,
    EDIT_STUDENT,
    LEND_BOOK,
    RETURN_BOOK,
    FETCH_RECORDS_REQUEST,
    FETCH_RECORDS_PASS
}